import { CRYPTO_CURRENCYS } from '@utils/consts'
import apiHelper from '@utils/cunstomInterseptor'

export const state = {
  minutes: 0,
  seconds: 0,
  hours: 0,
  action: {h: 0, m: 0},
  qrCodes: null,
  isError: false,
  timer: null,
  btn: false
}

export const mutations = {
  SET_TIMER (state, data) {
    state.hours = data.hours
    state.minutes = data.minutes
    state.seconds = data.seconds
  },
  SET_ERROR (state, data) {
    state.isError = data
  },
  SET_ACTION (state, data) {
    state.action.h = Number(data.hours) !== 0 ? Number(data.hours) - 1 : 0
    state.action.m = Number(data.minutes) === 0 ? 53 : Number(data.minutes) - 7 <= 0 ? 0 : Number(data.minutes) - 6
  },
  SET_QR_CODES (state, data) {
    state.qrCodes = data
  },
  setTimeValue (state, data) {
    state[data.val] = data.amount
  },
  decrementTimer (state, data) {
    if (data === 'h') {
      state.hours = Number(state.hours) - 1
    } else if (data === 'm') {
      state.minutes = Number(state.minutes) - 1
    } else if (data === 's') {
      state.seconds = Number(state.seconds) - 1
    }
  },
  setBtn (state, data) {
    state.btn = data
  },
  clearTimer (state) {
    clearInterval(state.timer)
    state.hours = 0
    state.minutes = 0
    state.seconds = 0
    state.timer = null
  }
}

function checkForm () {
  const form = document.querySelector('.withdraw__flex-wrapper')
  if (form) {
    const isInput = form.querySelector('input')
    if (isInput) {
      return Object.values(CRYPTO_CURRENCYS).includes(isInput.value)
    }
    return false
  }
  return false
}

function parseTimeString (timeString) {
  let hours = 0
  let minutes = 0
  let seconds = 0
  const hourMatch = timeString.match(/(\d+(\.\d+)?)h/)
  if (hourMatch) {
    hours = Math.floor(parseFloat(hourMatch[0]))
  }
  const minuteMatch = timeString.match(/(\d+(\.\d+)?)m/)
  if (minuteMatch) {
    minutes = Math.floor(parseFloat(minuteMatch[0]))
  }
  const secondMatch = timeString.match(/(\d+(\.\d+)?)s/)
  if (secondMatch) {
    seconds = Math.floor(parseFloat(secondMatch[0]))
  }
  return { hours, minutes, seconds }
}

export const actions = {
  async getTimer ({ commit, rootState, state }, reactivateWallet) {
    try {
      commit('SET_ERROR', false)
      commit('setBtn', false)
      let { data } = await apiHelper.post(`/create_wallet`, {
        reactivate_wallet: reactivateWallet
      })
      let { Expiring, Duration, ...others } = data
      let date = parseTimeString(Expiring)
      let dur = parseTimeString(Duration)
      commit('SET_TIMER', date)
      commit('SET_QR_CODES', others)
      commit('SET_ACTION', dur)
    } catch (err) {
      console.log(err)
      commit('SET_ERROR', true)
    }
  },
  async startTimer ({ commit, state, dispatch }, reactivateWallet = false) {
    state.timer = setInterval(() => {
      if (state.hours === 0 && state.minutes === 0 && state.seconds === 0) {
        if (checkForm()) {
          dispatch('getTimer', reactivateWallet)
          commit('setBtn', false)
        } else {
          commit('clearTimer')
        }
      } else {
        if (state.hours < state.action.h || (state.hours === state.action.h && state.minutes <= state.action.m)) {
          commit('setBtn', true)
        }
        if (state.seconds === 0 && state.minutes !== 0) {
          commit('decrementTimer', 'm')
          commit('setTimeValue', { val: 'seconds', amount: 59 })
        } else if (state.minutes === 0 && state.hours !== 0 && state.seconds === 0) {
          commit('decrementTimer', 'h')
          commit('setTimeValue', { val: 'minutes', amount: 59 })
          commit('setTimeValue', { val: 'seconds', amount: 59 })
        } else {
          commit('decrementTimer', 's')
        }
      }
    }, 1000)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/timer.module.js